import React, { Component } from 'react';

class Footer extends Component {
  render() {
    return (
      <footer className="app-footer">
        <a href="https://www.bosscarsoft.com/" rel="noopener noreferrer"  target="_blank">BossCarSoft</a> &copy; 2018
        <span className="float-right">Powered by
          <a href="http://www.appxar.co" rel="noopener noreferrer"  target="_blank">AppXar</a></span>
      </footer>
    )
  }
}

export default Footer;
